var exports = {
  "kL": "x2b2fbebb--76fd41--container",
  "DD": "x2b2fbebb--76fd41--title",
  "Pf": "x2b2fbebb--76fd41--label",
};

module.exports = exports;
